<h2 mat-dialog-title>Email Preview</h2>
<div class="email-meta">
  <div class="email-field">
    <span class="field-label">Subject</span>
    <strong>{{data.subject || 'No subject'}}</strong>
  </div>
  <div class="email-field">
    <span class="field-label">From</span>
    <strong>{{data.fromEmail}}</strong>
  </div>
</div>
<mat-dialog-content>
  <iframe
    *ngIf="data.body"
    [srcdoc]="data.body"
    sandbox=""
    title="Campaign email preview"
  ></iframe>
  <p class="unavailable" *ngIf="!data.body">Email body is unavailable for this campaign.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Close</button>
</mat-dialog-actions>